module.exports = __webpack_public_path__ + "img/pay.35879121.png";